<template>
  <label class="kt-checkbox kt-checkbox--bold">
    <input
      type="checkbox"
      :class="{ 'is-invalid': validator ? validator.$error : '' }"
      :value="value"
      v-bind="$attrs"
      v-on="listeners"
      :checked="value"> {{ label }}<slot />
    <span></span>
  </label>
</template>

<script>
export default {
  name: 'BaseRadioButton',
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: ''
    },
    isMandatory: {
      type: Boolean,
      default: false
    },
    validator: {
      type: Object,
      required: false
    },
    value: [Boolean]
  },
  methods: {
    updateValue (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
